import { Component } from 'react'

import { Program } from './Programs/Program'
import { Pagination } from './Programs/Pagination'
import { SortBy } from './Programs/SortBy'

export class Programs extends Component {

	render() {
		if ( ! this.props.isSearchingPrograms ) {

			let loadingClass = this.props.isSearchingPrograms ? 'pf-programs__list--loading' : ''
			return (
				<div className="pf-programs">
					
					<div className="pf-programs__container">
						<div className="pf-programs__result-count">
							We found {this.props.programsCount} Results
						</div>

						<SortBy 
							currentSortBy={ this.props.filters.sort_by } 
							updateFilter={ this.props.updateFilter }
						/>

						<div className={ `pf-programs__list ${loadingClass}` }>
							{this.props.programs.posts.map((program, index) => {
								return (
									<Program program={ program } placeholderImage={ this.props.placeholderImage } key={ index } />
								)
							})}
						</div>

						<Pagination 
							totalPages={ this.props.programs.max_num_pages } 
							currentPage={ this.props.filters.paged } 
							updateFilter={ this.props.updateFilter }
						/>
					</div>

				</div>
			)
		} else {
			return (
				<div className="pf-programs">
					<div className="pf-programs__loader">
						<div className="pf-programs__loader-inner"></div>
					</div>
				</div>
			)
		}
	}

}